<script lang="ts">

    import { browser } from "$app/environment";
    import { goto } from '$app/navigation';
    import { page } from '$app/stores';
    import { onMount } from "svelte";

	import { lazyLoad } from '$lib/actions/lazyLoad';
	
    import Cta from '$lib/components/Global/Cta.svelte';
    import __ from '$lib/stores/TranslationStore';

    
	import closebtn from '$lib/assets/images/hp_banner/close_outline.svg';
	import tagverao from '$lib/assets/images/hp_banner/tag_verao.svg';

    function setLocalStoragePDA2025(name, value, hours) {
        if (!browser) return; // Prevent errors during SSR

        const expirationTime = Date.now() + hours * 60 * 60 * 1000; // Convert hours to milliseconds
        const data = { value, expires: expirationTime };
        localStorage.setItem(name, JSON.stringify(data));
    }

    function getLocalStorage(name) {
        if (!browser) return null;

        const item = localStorage.getItem(name);
        if (!item) return null;

        const data = JSON.parse(item);
        if (Date.now() > data.expires) {
            localStorage.removeItem(name); 
            return null;
        }
        return data.value;
    }
    
    var showPDA = false;

    function pda2025Close(){
        showPDA = false;
        setLocalStoragePDA2025("pda2025", "off", 48);
    }

    function showPDA2025(){
        return getLocalStorage("pda2025") == null && ($page.url.pathname.search("/simuladores") == -1 && $page.url.pathname.search("/simulador/") == -1);
    }

    function redirectPDA(){
        pda2025Close();
        goto("/simuladores");
    }

    
    onMount(() => {
        showPDA = showPDA2025();

        console.log(showPDA);
    })
   

</script>
{#if showPDA}
<div class="font-['Sora'] fixed bg-white/90 rounded-[10px] md:rounded-[14px] md:flex max-sm:h-[155px] top-[90px] right-[10px] max-sm:left-[5px] max-sm:right-[5px] max-sm:top-[65px] md:w-[650px]" >
	<div class="md:flex p-[20px] max-sm:p-[10px] max-sm:mb-[0px]">
        <div class="flex w-3/3 gap-5 min-sm:gap-4">
            <div class="absolute cursor-pointer block md:hidden right-[10px] top-[10px]">
                <img
                use:lazyLoad={closebtn}
                alt="Fechar"
                class="w-[21px] w-[21px]"
                loading="lazy"
                on:click={pda2025Close}
            />
            </div>
            <div class="w-1/5 md:inline-block align-top mr-[0px] md:mr-[5px] w-[127px] md:w-[200px] h-[86px] md:h-[119px] border-[#263238] border-[1px] pl-[16px] rounded-bl-[7px] rounded-r-[7px] md:rounded-bl-[10px] md:rounded-r-[10px]">
                <div class="absolute text-[17px] md:text-[21px] top-[32px] left-[72px] md:top-[50px] md:left-[96px]">☀️</div>
                <img
                    use:lazyLoad={tagverao}
                    alt="o verão é seu. o trabalho nosso"
                    class="w-[110px] md:w-[165px] pr-[16px] mt-[10px] md:mt-[16px]"
                    loading="lazy"
                />
            </div>
            <div class="md:w-4/5 inline-block align-top ml-[-10px]">
                <div class="text-[16px] sm:text-[21px] md:text-[21px] font-[700] leading-[15px] sm:leading-[22px]">À procura do melhor!<br/> crédito? Nem precisa <br/> fazer scroll!</div>
                <div class="text-[14x] sm:text-[18px] font-[400] leading-[14px] sm:leading-[20px] mt-[10px]">Simule já e nós tratamos! <br/> de tudo por si.</div>
            </div>
        </div>

        <div class="hidden md:block md:block md:w-2/4 max-sm:w-1/4 md-inline-block align-top max-w-[171px] ml-[10px] max-sm:mr-[5px]">
            <Cta
					type="button"
                    class="w-full max-sm:w-[98px] max-sm:rounded-[4px] rounded-[7px] text-[17px] max-sm:text-[9px] max-sm:h-4 max-sm:p-[18px]"

                    id="pda-2025-cta"
					on:click={redirectPDA}
				>
                    <span class="hidden sm:block">{$__('Simular crédito')}</span>
                    <span class="block sm:hidden">{$__('Simular agora')}</span>
				</Cta>
            <Cta
					type="button"
					class="hidden md:block relative w-full max-sm:w-[98px] max-sm:rounded-[4px] rounded-[7px] mt-[12px] max-sm:mt-[10px] bg-[#D0EADC] text-[#018171] text-[17px] max-sm:text-[9px] max-sm:h-4 max-sm:p-[18px] p-[0px]"
					on:click={pda2025Close}
				>
					{$__('Fechar')}
				</Cta>
        </div>

       
	</div>
    <div class="flex-none block md:hidden ml-[10px] mr-[10px] pb-[10px]">
        <Cta
        type="button"
        class="w-full clear-both max-sm:rounded-[4px] rounded-[7px] text-[12px] max-sm:h-4 max-sm:p-[18px]"

        id="pda-2025-cta"
        on:click={redirectPDA}
    >
        <span class="hidden sm:block">{$__('Simular crédito')}</span>
        <span class="block sm:hidden">{$__('Simular agora')}</span>
    </Cta>
    </div>
</div>
{/if}